export default "__VITE_ASSET__D0j9QK3T__"